<template>
  <nav-tabs-card class="tasks-list">
    <template slot="content">
      <span class="md-nav-tabs-title">
        <div class="card-icon">
          <md-icon class="icon">check_circle_outline</md-icon>
        </div>
        Aufgaben
      </span>
      <md-tabs
        class="md-rose"
        md-alignment="left"
        @md-changed="e => (currentTab = e)"
      >
        <md-tab
          id="tasks--assigned"
          md-label="Zugewiesen"
          md-icon="assignment_ind"
        >
          <TaskList
            ref="tasks--assigned"
            :active="currentTab === 'tasks--assigned'"
            filter="assigned"
            @edit="editTask = $event"
          ></TaskList>
        </md-tab>

        <md-tab id="tasks--all" md-label="Alle" md-icon="assignment">
          <TaskList
            ref="tasks--all"
            :active="currentTab === 'tasks--all'"
            filter="all"
            @edit="editTask = $event"
          ></TaskList>
        </md-tab>

        <md-tab id="tasks--done" md-label="Erledigt" md-icon="done">
          <TaskList
            ref="tasks--done"
            :active="currentTab === 'tasks--done'"
            filter="done"
            @edit="editTask = $event"
          ></TaskList>
        </md-tab>
      </md-tabs>
      <md-button
        class="md-raised md-primary md-round"
        @click="
          editTask = {
            type: 'tasks',
            author: user,
            assignee_id: user.id,
            created_at: new Date(),
            description: ''
          }
        "
      >
        <md-icon>add</md-icon>
        <md-tooltip md-direction="bottom">Aufgabe hinzufügen</md-tooltip>
      </md-button>
      <md-dialog
        :md-active="editTask !== false"
        @update:active="e => (editTask = e)"
        class="task-edit-dialog"
      >
        <md-dialog-title>Aufgabe</md-dialog-title>
        <EditTask
          v-model="editTask"
          @saved="
            editTask = false;
            refresh();
          "
          ref="taskEditDialog"
        ></EditTask>
        <md-dialog-actions>
          <md-button @click="editTask = false">Abbrechen</md-button>
          <md-button @click="$refs.taskEditDialog.save()" class="md-success"
            >Übernehmen</md-button
          >
        </md-dialog-actions>
      </md-dialog>
    </template>
  </nav-tabs-card>
</template>

<style scoped lang="scss">
.icon {
  font-size: 30px !important;
  margin-right: 5px;
}
.md-nav-tabs-title ::v-deep .card-icon {
  display: inline-block;
  position: relative;
  top: -2px;

  i {
    color: #fff;
  }
}

.tasks-list ::v-deep .md-tabs-navigation {
  padding-left: 130px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 6px;
}

.tasks-list ::v-deep .md-card-content {
  padding: 15px;
}
</style>

<script>
import { NavTabsCard } from "@/components";
import TaskList from "@/components/Clouseau/TaskList.vue";
import EditTask from "@/components/Clouseau/EditTask.vue";
export default {
  components: {
    NavTabsCard,
    TaskList,
    EditTask
  },
  data() {
    return {
      loading: false,
      currentTab: "tasks_assigned",
      editTask: false,
      newTaskDescription: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    this.$store.dispatch("profile/me");
    this.$store.dispatch("users/list", { page: { size: 100 } });
  },
  methods: {
    refresh() {
      this.$refs[this.currentTab].get();
    }
  }
};
</script>
